export default {
    methods: {
        formValidationUtil(item, status, message) {
            item.valid = status
            item.validationMessage = message            
        }
    }
}